export default __webpack_public_path__ + "static/media/backcirclegray.265421aa.svg";